import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, pluck } from 'rxjs/operators';
import { getAllCourses, getCompanyName, getCourseCategory, getCourseDetailsPreview, getCourseRegisteredUsers, getCoursesCountByStatus, getCourseType, getRegisteredCoursesByUser, listAllCourses, supplierProfileData,getMyCourseData, getRegisterUserTabCounts } from '../queries/course.query';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';

@Injectable({
    providedIn: 'root'
})
export class CourseSectionService {

    constructor(private apollo: Apollo, private loginService: LoginService) { }

    // createCourse(data: any): Promise<any> {
    //     return this.apollo.mutate({
    //         mutation: insertCourseMutation,
    //         variables: {
    //             object: data
    //         }
    //     })
    //         .pipe(map((res: any) => res?.data?.insert_courses_one))
    //         .toPromise();
    // }

    // updateCourse(id: string, data: any): Promise<any> {
    //     return this.apollo.mutate({
    //         mutation: updateCourseMutation,
    //         variables: {
    //             id: id,
    //             changes: data
    //         }
    //     })
    //         .pipe(map((res: any) => res?.data?.update_courses_by_pk))
    //         .toPromise();
    // }


    getCourseType(limit?: number, offset?: number, search?: string): Observable<any> {
        const searchValue = search ? `%${search}%` : "%%";
        return this.apollo.use('external').query({
            query: getCourseType,
            variables: {
                limit,
                offset,
                search: searchValue // always a string, no undefined
            },
        }).pipe(pluck('data', 'course_type'));
    }



    getCompanyName(limit: number, offset: number, search: string = ""): Observable<any> {
        const searchValue = search ? `%${search}%` : "%%"; // ilike needs wildcard
        return this.apollo.use("external").query({
            query: getCompanyName,
            variables: { limit, offset, search: searchValue },
        }).pipe(pluck('data', 'courses'));
    }


    getCourseCategories(): Observable<any> {
        return this.apollo.use("external").subscribe({
            query: getCourseCategory
        }).pipe(pluck('data', 'course_categories'));
    }

    getAllCourses(
        limit: number,
        offset: number,
        status?: string,
        active_status?: string,
        search?: string,
        type?: string,
        company?: string,
        month?: string
    ): Observable<any> {
        const { id: userId, type: userType } = this.loginService.getLoginData();
        const isAdmin = userType === 'ADMIN';
        const isSupplier = userType === 'SUPPLIER';


        let where: any = {};

        // Active status
        if (active_status) {
            where.active_status = { _eq: active_status };
        }

        // Role & Status
        if (status === 'DRAFT') {
            where = { ...where, status: { _eq: 'DRAFT' }, created_by_id: { _eq: userId } };
        } else if (isSupplier) {
            where = { ...where, created_by_id: { _eq: userId } };
            if (status) {
                where.status = { _eq: status };
            }
        } else if (isAdmin) {
            if (status) {
                where = { ...where, status: { _eq: status } };
            } else {
                where = {
                    ...where,
                    _or: [
                        { status: { _neq: 'DRAFT' } },
                        { created_by_id: { _eq: userId } }
                    ]
                };
            }
        }

        if (search && search.trim() !== '') {
            const searchFilter = {
                _or: [
                    { course_name: { _ilike: `%${search}%` } },
                    { presented_by_name: { _ilike: `%${search}%` } },
                    { company_name: { _ilike: `%${search}%` } }
                ]
            };
            where = { _and: [where, searchFilter] };
        }

        // filters for admin
        if (isAdmin) {
            const adminFilters: any[] = [];
            if (type?.trim()) {
                adminFilters.push({ type: { _ilike: `%${type}%` } });
            }
            if (company?.trim()) {
                adminFilters.push({ company_name: { _ilike: `%${company}%` } });
            }
            if (month?.trim()) {
                adminFilters.push({
                    _and: [
                        { startDate: { _lte: month } },
                        { endDate: { _gte: month } }
                    ]
                });
            }

            if (adminFilters.length) {
                where = { _and: [where, ...adminFilters] };
            }
        }


        return this.apollo.subscribe({
            query: listAllCourses,
            variables: { where, limit, offset },
            fetchPolicy: 'network-only'

        });

    }

    getCoursesTabCounts(): Observable<any> {
        const loginData = this.loginService.getLoginData();
        const userId = loginData?.id;
        const isSupplier = loginData?.type === 'SUPPLIER';
        const isAdmin = loginData?.type === 'ADMIN';

        let whereAll: any;
        if (isSupplier) {
            whereAll = { created_by_id: { _eq: userId } };
        } else if (isAdmin) {
            whereAll = {
                _or: [
                    { status: { _neq: 'DRAFT' } },
                    { created_by_id: { _eq: userId } }
                ]
            };
        } else {
            whereAll = {};
        }

        // DRAFT tab
        let whereDraft: any = {
            status: { _eq: 'DRAFT' },
            created_by_id: { _eq: userId }
        };

        const baseWhere = isSupplier ? { created_by_id: { _eq: userId } } : {};

        return this.apollo.subscribe({
            query: getCoursesCountByStatus,
            variables: {
                whereAll,
                whereDraft,
                where: baseWhere
            }
        });
    }
    // getCourseById(id: string): Observable<any> {
    //     return this.apollo
    //         .query({
    //             query: GetCourseById,
    //             variables: { id },
    //             fetchPolicy: 'network-only'
    //         })
    //         .pipe(pluck('data', 'courses_by_pk'));
    // }

    // getCourseDetailsPreview(id: string | number): Observable<any[]> {
    //     return this.apollo
    //         .use('external')
    //         .query({
    //             query: getCourseDetailsPreview,
    //             variables: { id }
    //         })
    //         .pipe(pluck('data', 'courses'));
    // }

    // deleteCoursePost(courseId: string): Promise<any> {
    //     return this.apollo
    //         .mutate({
    //             mutation: deleteCourseFromListMutation,
    //             variables: { id: courseId },
    //         })
    //         .toPromise();
    // }

    // updateCourseActiveStatus(courseId: string, status: string): Observable<any> {
    //     return this.apollo.mutate({
    //         mutation: updateCourseStatusMutation,
    //         variables: {
    //             id: courseId,
    //             status: status
    //         }
    //     });
    // }

    // updateCourseStatus(courseId: string, status: string): Observable<any> {
    //     return this.apollo.mutate({
    //         mutation: updateCourseApproveStatusMutation,
    //         variables: {
    //             id: courseId,
    //             status: status
    //         }
    //     });
    // }

    // registerUser(payload: any) {
    //     return this.apollo.use('external').mutate({
    //         mutation: registerUserMutation,
    //         variables: { object: payload }
    //     }).pipe(pluck('data', 'insert_course_registered_users_one'));
    // }

    // getRegCourseById(id: string): Observable<any> {
    //     return this.apollo
    //         .query({
    //             query: getRegCourseById,
    //             variables: { id },
    //         })
    //         .pipe(pluck('data', 'courses_by_pk'));
    // }

    getCourseRegisteredUsers(courseId: string, limit: number, offset: number, status?: string) {

        let where: any = {
            course_id: { _eq: courseId }
        };

        if (status === 'ALL') {
            where.status = { _in: ['PENDING', 'APPROVED', 'CANCELLED', 'COMPLETED'] };
        } else if (status) {
            where.status = { _eq: status };
        }

        return this.apollo.use('external').watchQuery<any>({
            query: getCourseRegisteredUsers,
            variables: {
                limit: limit,
                offset: offset,
                where: where
            }
        }).valueChanges.pipe(pluck('data', 'course_registered_users'));
    }

    getRegisteredCourses(
        limit: number = 10,
        offset: number = 0,
        searchTerm?: string,
        type?: string,
        category?: string,
        month?: string
    ) {
        const loginDetails = this.loginService.getLoginData();
        const loginId = loginDetails?.id;

        const andConditions: any[] = [
            { course_registered_users: { from_id: { _eq: loginId } } }
        ];

        // Type filter
        if (type) {
            andConditions.push({ type: { _eq: type } });
        }

        // Category filter (by name using relation)
        if (category?.trim()) {
            andConditions.push({
                course_category: { name: { _eq: category.trim() } }
            });
        }

        // Search filter
        const trimmedSearch = (searchTerm ?? '').trim();
        if (trimmedSearch) {
            const safe = trimmedSearch.replace(/[%_]/g, '\\$&');
            const ilike = `%${safe}%`;
            andConditions.push({
                _or: [
                    { company_name: { _ilike: ilike } },
                    { course_name: { _ilike: ilike } },
                    { presented_by_name: { _ilike: ilike } }
                ]
            });
        }

        if (month?.trim()) {
            andConditions.push({
                _and: [
                    { startDate: { _lte: month } },
                    { endDate: { _gte: month } }
                ]
            });
        }
        const whereCondition = { _and: andConditions };
        return this.apollo.query<any>({
            query: getRegisteredCoursesByUser,
            variables: {
                where: whereCondition,
                limit,
                offset,
                loginId
            },
            fetchPolicy: 'network-only'
        });


    }

//      updateWebinarStatus(Id: string, status: string): Observable<any> {
//     return this.apollo.mutate({
//       mutation: updateWebinarStatus,
//       variables: {
//         id: Id,
//         status: status,
//       },
//     });
//   }

    getSupplierDataInfo(id: string): Observable<any> {
        return this.apollo
            .use('external')
            .subscribe({
                query: supplierProfileData,
                variables: { id },
            })
            .pipe(pluck('data', 'dental_suppliers_by_pk'));
    }

      getMyCourseData(communityId?: string) {
      const where: any = {
        _and: [
            { community_id: { _eq: communityId } },
            { community_status: { _eq: "YES" } },
            { active_status: { _eq: "ACTIVE" } },
            { status: { _eq: "APPROVE" } },
        ]
      };
    
      return this.apollo.use('external').watchQuery({
          query: getMyCourseData,
          variables: { where },
        }).valueChanges.pipe(pluck('data', 'courses'));
    }

getRegisterUserTabCounts(courseId: string): Observable<any> {

  const where = {
    course_id: { _eq: courseId }
  };

  return this.apollo.use('external').watchQuery<any>({
    query: getRegisterUserTabCounts,
    variables: { where }
  }).valueChanges;
}


}
